import React, { useState } from 'react';
import EditorSettings from '@wix/da-ds/pkg/Icons/24x24/EditorSettings';
import { useTranslation } from 'react-i18next';
import SettingsForm from './SettingsForm';
import EditorIconButton from '../../../../../components/menus/_partials/EditorIconButton';
const Settings = ({ editor })=>{
    const { t } = useTranslation('editor');
    const [showSettings, setShowSettings] = useState(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showSettings && /*#__PURE__*/ React.createElement(SettingsForm, {
        editor: editor,
        onClose: ()=>{
            setShowSettings(false);
        }
    }), /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:gallery:settings",
        icon: EditorSettings,
        onClick: ()=>{
            setShowSettings(true);
        },
        tooltipText: t('ext.gallery.toolbar.settings'),
        "aria-label": t('ext.gallery.toolbar.settings')
    }));
};
Settings.displayName = 'Settings';
export default Settings;

//# sourceMappingURL=Settings.js.map